import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { mapStyles } from '../utils/map-styles';

(function (once, Drupal) {
  Drupal.behaviors.projectsMapBehavior = {
    attach: function (context, settings) {
      const scrollPositionStorageKey = 'casp.projectsMapBehavior.scrollState';

      once(
        'projectsMapBehavior',
        '.paragraph--type--project-map',
        context
      ).forEach(function (rootNode) {
        const markersData = rootNode.dataset?.markersdata
          ? JSON.parse(rootNode.dataset?.markersdata)
          : [];
        const sidebar = rootNode.querySelector('.sidebar');
        const closeSidebar = rootNode.querySelector('.sidebar-close');
        const init = { lat: 52.6, lng: -3.7 };
        let topLevelMarkers = [];

        const saveScrollPosition = () => {
          sessionStorage.setItem(
            scrollPositionStorageKey,
            JSON.stringify({
              pathname: window.location.pathname,
              scrollY: window.scrollY,
            })
          );
        };

        const restoreScrollPosition = () => {
          const storedState = sessionStorage.getItem(scrollPositionStorageKey);

          if (!storedState) {
            return;
          }

          let parsedState;

          try {
            parsedState = JSON.parse(storedState);
          } catch (error) {
            sessionStorage.removeItem(scrollPositionStorageKey);
            return;
          }

          if (
            parsedState?.pathname !== window.location.pathname ||
            typeof parsedState?.scrollY !== 'number'
          ) {
            sessionStorage.removeItem(scrollPositionStorageKey);
            return;
          }

          sessionStorage.removeItem(scrollPositionStorageKey);

          window.requestAnimationFrame(() => {
            window.scrollTo({
              top: parsedState.scrollY,
              left: 0,
              behavior: 'auto',
            });
          });
        };

        const bindFilterForms = () => {
          once('projectsMapFilterSubmit', 'form', rootNode).forEach((form) => {
            form.addEventListener('submit', saveScrollPosition);
          });
        };

        const checkUrlParameters = () => {
          const urlParams = new URLSearchParams(window.location.search);
          const paramsToCheck = [
            'location',
            'priority_area',
            'suitable_for_ages',
          ];
          return paramsToCheck.some((param) => urlParams.has(param));
        };

        if (checkUrlParameters()) {
          sidebar.classList.add('active');
        }

        restoreScrollPosition();
        bindFilterForms();

        const updateSidebar = (marker) => {
          sidebar.classList.add('active');
          updateSidebarRows(marker);
        };

        const updateSidebarRows = (marker) => {
          const rows = sidebar.querySelectorAll('.views-row');
          rows.forEach((row) => {
            const otherRows = Array.from(rows).filter(
              (otherRow) => otherRow !== row
            );
            const rowTitles = row.querySelectorAll('.views-field-title');
            rowTitles.forEach((link) => {
              if (link.innerText.toLowerCase() === marker.toLowerCase()) {
                scrollSidebarToElement(row);

                row.classList.add('active');

                otherRows.forEach((otherRow) => {
                  otherRow.classList.remove('active');
                });
              }
            });
          });
        };

        const scrollSidebarToElement = (element) => {
          const parentRect = sidebar.getBoundingClientRect();
          const rowRect = element.getBoundingClientRect();

          // Calculate the target scroll position
          const targetScrollTop =
            rowRect.top -
            parentRect.top +
            sidebar.scrollTop -
            sidebar.clientHeight / 2 +
            rowRect.height / 2;

          // Smoothly scroll the parent element to the target position
          sidebar.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth',
          });
        };

        const smoothZoom = (map, targetZoom, duration) => {
          const currentZoom = map.getZoom();
          const zoomStep = (targetZoom - currentZoom) / (duration / 100);

          const zoomIn = () => {
            if (Math.abs(targetZoom - map.getZoom()) > 0.1) {
              map.setZoom(map.getZoom() + zoomStep);
              setTimeout(zoomIn, 100);
            } else {
              map.setZoom(targetZoom);
            }
          };

          zoomIn();
        };

        const sidebarActionButtons = (map) => {
          const buttons = document.querySelectorAll('.views-row');
          if (!buttons) return;
          buttons.forEach((button) => {
            button.addEventListener('click', () => {
              topLevelMarkers.forEach((marker) => {
                if (
                  button
                    .querySelector('.views-field-title')
                    .innerText.toLowerCase()
                    .trim() == marker.title.toLowerCase().trim()
                ) {
                  if (map.getZoom() < 13) {
                    smoothZoom(map, 13, 1000);
                  }
                  map.panTo(marker.getPosition());
                  toggleMarkerBounce(marker);
                }
              });

              const otherButtons = Array.from(buttons).filter(
                (otherButton) => otherButton !== button
              );
              button.classList.add('active');
              otherButtons.forEach((otherButton) => {
                otherButton.classList.remove('active');
              });
            });
          });

          closeSidebar?.addEventListener('click', () => {
            console.log('cklick');
            if (sidebar.classList.contains('active')) {
              sidebar.classList.remove('active');
            } else {
              sidebar.classList.add('active');
            }
          });
        };

        const toggleMarkerBounce = (marker) => {
          if (marker.getAnimation() !== null) {
            marker.setAnimation(null);
          } else {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => {
              marker.setAnimation(null);
            }, 1000);
          }
        };

        const createMarkers = (map) => {
          const beachFlagImg =
            '/themes/custom/casp/images/icons/iconMapMarker.svg';
          const markers = markersData.map((markerDataset) => {
            const marker = new google.maps.Marker({
              position: {
                lat: Number(markerDataset.geometry.coordinates.lat),
                lng: Number(markerDataset.geometry.coordinates.lng),
              },
              icon: beachFlagImg,
              map,
              title: markerDataset.properties.label,
            });
            marker.addListener('click', () => {
              updateSidebar(marker.title);
            });
            marker.setAnimation(null);

            return marker;
          });

          const renderer = {
            render: ({ count, position }) =>
              new google.maps.Marker({
                label: {
                  text: String(count),
                  color: 'black',
                  fontSize: '18px',
                  fontWeight: 'bold',
                },
                icon: '/themes/custom/casp/images/icons/iconMapCluster.svg',
                position,
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              }),
          };

          topLevelMarkers.push(...markers);
          new MarkerClusterer({ markers, map, renderer });
        };

        const mapLoader = new Loader({
          apiKey: 'AIzaSyCJlLs_1lcfX2iu4Pv5yHNPNpyMC4wvbN8',
          version: '3.58',
          libraries: ['places'],
        });

        const mapOptions = {
          center: init,
          zoom: 8,
          styles: mapStyles,
        };

        mapLoader.loadCallback((e) => {
          if (e) {
            console.error(e);
          } else {
            const map = new google.maps.Map(
              document.getElementById('mapDiv'),
              mapOptions
            );

            createMarkers(map);
            sidebarActionButtons(map);
          }
        });

        sidebar.addEventListener('scroll', () => {
          closeSidebar.style.top = `${sidebar.scrollTop}px`;
        });
      });
    },
  };
})(once, Drupal);
